import { useState, useEffect, useContext } from "react";

// react-router components
import { useLocation, Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
} from "context";
import { baseUrladmin } from "assets/js/config/config";
import { Select } from "antd";
import DropdownContext from "shared/ContextStore/DropdownContext";

const { Option } = Select;
function DashboardNavbar({ absolute, light, isMini }) {
  const { dropdownValue, setDropdownValue, dropdownName, setDropdownName } =
    useContext(DropdownContext);
  const AccessToken = localStorage.getItem("accessToken");
  const [companytypes, setCompanytypes] = useState([]);
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, darkMode } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  const name = localStorage.getItem("firstName");
  const [cmptype, setcmptype] = useState(null);
  // const [companytypes, setCompanytypes] = useState([]);

  // Initialize dropdownName with the company name from localStorage if companyId is present
  // const initialCompanyId = localStorage.getItem("companyId");
  // const initialCompanyName = companytypes.find(
  //   (company) => company.companyId === initialCompanyId
  // )?.companyName;
  const [selectedCompanyId, setSelectedCompanyId] = useState("");

  // useEffect(() => {
  //   const selectedCompanyName = companytypes.find(
  //     (company) => company.companyId === dropdownValue
  //   );
  //   setDropdownName(selectedCompanyName?.companyName);
  // }, []);

  useEffect(() => {
    // Load the selected companyId from localStorage (if available)
    const storedCompanyId = localStorage.getItem("companyId");
    if (storedCompanyId) {
      setSelectedCompanyId(storedCompanyId);
      const selectedCompanyName = companytypes.find(
        (company) => company.companyId === dropdownValue
      );
      setDropdownName(selectedCompanyName?.companyName);
    }
  }, [dropdownValue]);

  const handleCompanyChange = (value) => {
    setSelectedCompanyId(value);
    // Save the selected companyId to localStorage
    localStorage.setItem("companyId", value);

    // Find and log the corresponding company name based on companyId
    const selectedCompany = companytypes.find(
      (company) => company.companyId === value
    );
    if (selectedCompany) {
      setDropdownValue(value);
      console.log("Selected companyId:", value);
      console.log("Selected companyName:", selectedCompany?.companyName);
    }
  };

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleUpdate = () => {
    localStorage.clear();
  };
  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  // const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  // const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem
        icon={<Icon>podcasts</Icon>}
        title="Manage Podcast sessions"
      />
      <NotificationItem
        icon={<Icon>shopping_cart</Icon>}
        title="Payment successfully completed"
      />
    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({
    palette: { dark, white, text },
    functions: { rgba },
  }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  useEffect(() => {
    fetch(baseUrladmin + "company/getAllCollegesUnderMe", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${AccessToken}`,
        "Content-type": "application/json; charset=UTF-8",
        companyId: localStorage.getItem("companyId"),
      },
      body: JSON.stringify({
        companyId: "",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == -1) {
          setCompanytypes([]);
        } else {
          setCompanytypes(data.data);
          if (roles === "ROLE_COLLEGE") {
            setcmptype(data.data[0]?.companyId);
          }
        }
        setdestcmpid(data.data[0]?.companyId);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) =>
        navbar(theme, { transparentNavbar, absolute, light, darkMode })
      }
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox
          color="inherit"
          mb={{ xs: 1, md: 0 }}
          sx={(theme) => navbarRow(theme, { isMini })}
        >
          <Breadcrumbs
            icon="home"
            title={route[route.length - 1]}
            route={route}
            light={light}
          />
        </MDBox>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            <MDBox color={light ? "white" : "inherit"}>
              {/* <MDBox pr={1}>
              </MDBox> */}
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>

              {/* <select
                onChange={handlSelect}
                style={{ height: "27px", width: "11rem" }}
              >
                {companytypes.length > 1 && (
                  <option value="all"> --- All --- </option>
                )}
                {companytypes.length === 1 ? (
                  <option value={companytypes[0].companyId}>
                    {companytypes[0].companyName}
                  </option>
                ) : (
                  companytypes.map((companytype) => (
                    <option value={companytype.companyId}>
                      {companytype.companyName}
                    </option>
                  ))
                )}
              </select> */}
              <Select
                placeholder="Select a company"
                style={{ width: 200, marginRight: "5px" }}
                onChange={handleCompanyChange}
                value={selectedCompanyId}
              >
                {companytypes.map((company) => (
                  <Option key={company.companyId} value={company.companyId}>
                    {company.companyName}
                  </Option>
                ))}
              </Select>
              {name}
              <Link to="/authentication/sign-in/basic">
                <IconButton
                  onClick={(e) => handleUpdate()}
                  sx={navbarIconButton}
                  size="small"
                  disableRipple
                  style={{ marginLeft: "0px" }}
                >
                  Log Out
                  <Icon sx={iconsStyle}>
                    <span className="material-icons">logout</span>
                  </Icon>
                </IconButton>
              </Link>
              {/* <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
              >
                <Icon sx={iconsStyle}>settings</Icon>
              </IconButton> */}
              {/* <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                <Icon sx={iconsStyle}>notifications</Icon>
              </IconButton> */}
              {renderMenu()}
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
